// dependencies
import React, { useState, useMemo } from 'react'
import { string } from 'prop-types'
import SuccessIcon from '@mui/icons-material/CheckCircleOutline'
import { styled, Typography, Container, Box } from '@mui/material'
// helpers
// components
import EmailSubscribeForm from '@components/footer/email-subscribe-form'
// assets
import RTGLogo from '@shared/svgs/logo'

const StyledContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: '#07263B',
  padding: '1.2rem',
  height: '100%',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

const StyledLeftContainer = styled(Box)(({ theme }) => ({
  width: '30%',
  display: 'flex',
  alignItems: 'center',
  paddingRight: '1.6rem',
  marginRight: '1.6rem',
  borderRight: `1px solid ${theme.palette.common.white}`,
  svg: {
    width: '230px',
    height: '100%',
  },
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}))

const StyledEmailSubscribeForm = styled(EmailSubscribeForm)(({ theme }) => ({
  color: theme.palette.common.white,
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
  form: {
    display: 'grid',
    gap: '16px',
    gridTemplateColumns: '1fr 200px',
    alignItems: 'flex-start',
    '.MuiFormControl-root': {
      width: '100%',
    },
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'unset',
    },
  },
  legend: {
    fontSize: '16px',
    lineHeight: 'initial',
    fontWeight: '500',
    marginBottom: '12px',
  },
  button: {
    color: '#07263B',
    backgroundColor: '#ffcb00',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: 'initial',
    borderRadius: '4px',
    textTransform: 'uppercase',
    minHeight: '38px',
  },
  '.footer__email-subscribe-form__field-error': {
    color: theme.palette.error.main,
  },
}))

const StyleSuccessMessageContainer = styled(Container)(({ theme }) => ({
  p: {
    color: theme.palette.common.white,
    fontWeight: '600',
    fontSize: '16px',
  },
  svg: {
    fill: theme.palette.success.main,
    width: '64px',
    height: '64px',
  },
}))

export default function SubscribeForm({ subsourcecode }) {
  const [successSubscription, setSuccessSubscription] = useState(false)
  const successMessage = 'Signed up for email successfully!'

  return (
    <StyledContainer>
      <StyledLeftContainer>
        <RTGLogo uniqueNameForId="subscribeform" fillColor="#fff" />
      </StyledLeftContainer>
      {!successSubscription ? (
        <StyledEmailSubscribeForm
          supressZipCode
          supressInfoMessage
          subsourcecode={subsourcecode}
          onSuccessCallback={() => setSuccessSubscription(true)}
        />
      ) : (
        <StyleSuccessMessageContainer>
          <SuccessIcon />
          <Typography>{successMessage}</Typography>
        </StyleSuccessMessageContainer>
      )}
    </StyledContainer>
  )
}

SubscribeForm.propTypes = {
  subsourcecode: string,
}
